import React from "react";

export default function AchivementCard({ cardInfo }) {
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }

    var win = window.open(url, "_blank");
    win.focus();
  }

  const imageSrc = cardInfo.image
    ? require(`../../assets/images/${cardInfo.image}`)
    : null;

  return (
    <div className="certificate-card">
      {imageSrc && (
        <div className="certificate-image-div">
          <img
            src={imageSrc}
            alt={cardInfo.title || "Achievement"}
            className="card-image"
          ></img>
        </div>
      )}
      <div className="certificate-detail-div">
        <h5 className="card-title">{cardInfo.title}</h5>
        <p className="card-subtitle">{cardInfo.description}</p>
      </div>
      <div className="certificate-card-footer">
        {(cardInfo.footer || []).map((v, i) => {
          return (
            <p
              key={v.name || `footer-${i}`}
              onClick={() => openUrlInNewTab(v.url)}
            >
              {v.name}
            </p>
          );
        })}
      </div>
    </div>
  );
}
